import API from '../apiCreate'
import { getParams } from '../getParams'
import type {
  ResponseCrmLeadParentCandidates,
  ResponseCrmLeadParentIntegrationFields,
  ResponseCrmLeadParentMutation,
  ResponseCrmLeadParents,
} from '../types/crm/crmLeadParent.types'

/** Привязка родителей к лиду: `/v1/crm-lead-parent/*`. */
export const crmLeadParentApi = {
  getParents: (params: { lead_id: number }) =>
    API.get<ResponseCrmLeadParents>(
      `crm-lead-parent/index${getParams(params)}`,
    ),

  getCandidates: (params: {
    lead_id: number
    search?: string
    page?: number
    per_page?: number
  }) =>
    API.get<ResponseCrmLeadParentCandidates>(
      `crm-lead-parent/candidates${getParams(params)}`,
    ),

  attach: (params: { lead_id: number; parent_id: number }) =>
    API.post<ResponseCrmLeadParentMutation>(
      `crm-lead-parent/attach${getParams(params)}`,
    ),

  detach: (params: { lead_id: number; parent_id: number }) =>
    API.delete<ResponseCrmLeadParentMutation>(
      `crm-lead-parent/detach${getParams(params)}`,
    ),

  /**
   * Values integration-полей родителя.
   * Бэк читает только body (`load(getBodyParams())`) — lead_id/parent_id в query игнорируются.
   */
  updateIntegrationFields: (data: {
    lead_id: number
    parent_id: number
    fields: Record<string, string>
  }) =>
    API.put<ResponseCrmLeadParentIntegrationFields>(
      'crm-lead-parent/integration-fields',
      data,
    ),
}
